export const SETTINGS = {
	POST_LENGTH: {
		MIN: 20,
		MAX: 400,
		STEP: 10,
		DEFAULT: 200
	},
	POST_EMOJIS: {
		MIN: 0,
		MAX: 3,
		STEP: 1,
		DEFAULT: 1
	},
	POST_MODEL: {
		DEFAULT: 'advance'
	},
};